module.exports = "<cw-navbar></cw-navbar>\n<router-outlet></router-outlet>\n<!-- <button (click)=\"logstate()\">State</button> -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/composer/composer.component.html
// module id = 1663
// module chunks = 0